import buildQuery from 'hero-utils/buildQueryParams';
const buildUrl = (base, queryParams) => queryParams ? `${base}${buildQuery(queryParams)}` : base;
export default buildUrl;
//# sourceMappingURL=buildUrl.js.map